"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputDate = exports.createInputDate = exports.InputDateComponent = exports.InputDateDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var field_container_1 = require("../elements/field-container");
var fecha_1 = __importDefault(require("fecha"));
var react_date_picker_1 = __importDefault(require("react-date-picker"));
var react_datetime_picker_1 = __importDefault(require("react-datetime-picker"));
var use_form_state_1 = require("../../hooks/use-form-state");
var lodash_1 = require("lodash");
var cell_label_1 = require("../elements/cell-label");
var use_lang_1 = require("../../hooks/use-lang");
var memo = React.memo;
exports.InputDateDefaultProps = {
  displayFormat: "Dj MMM YYYY"
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    padding-top: ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(0.5))
});
var DatePickerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    .react-date-picker__inputGroup__input--hasLeadingZero,\n      .react-datetime-picker__inputGroup__input--hasLeadingZero {\n        margin-left: -2px !important;\n      }\n\n    .react-calendar {\n      top: 1px;\n      transition: border 0.2s;\n      position: relative;\n      border: 1px solid ", ";\n      font-family: ", ";\n\n\n      .react-calendar__month-view__days__day--weekend {\n        color: ", ";\n      }\n\n      .react-calendar__tile--active {\n        color: #FFF;\n        background-color: ", ";\n      }\n\n      abbr {\n        text-decoration: none;\n      }\n\n      button {\n        font-weight: 400;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        font-family: ", ";\n        font-size: ", ";\n      }\n\n      button.react-calendar__navigation__arrow {\n        font-family: 'Trebuchet MS', Arial, sans-serif;\n        font-size: ", ";\n        padding-top: 0px;\n        padding-bottom: 0px;\n      }\n\n      button.react-calendar__navigation__label {\n        padding: 0;\n        text-transform: uppercase;\n        font-weight: 500;\n        font-size: ", ";\n      }\n\n      .react-calendar__navigation {\n        margin-bottom: 6px;\n        border-bottom: 1px solid ", "; \n      }\n    \n    \n    }\n\n    .react-date-picker__wrapper {\n      width: 220px;\n    }\n\n    .react-datetime-picker__wrapper {\n      width: 280px;\n    }\n\n    .react-date-picker__wrapper,\n    .react-datetime-picker__wrapper {\n      padding: ", ";\n      transition: border 0.2s;\n      flex-grow: 0;\n      border: 1px solid ", ";\n      \n      button {\n        svg {\n          height: 16px;\n          width: 16px;\n        }\n        padding-left: 12px;\n        padding-right: 12px;\n        outline: none;\n        line, rect, path {\n          stroke: ", ";\n        }\n\n        &:focus, &:hover {\n          line, rect, path {\n          stroke: ", ";\n        }\n        }\n      }\n\n      .react-date-picker__inputGroup,\n      .react-datetime-picker__inputGroup {\n        padding: ", ";\n      }\n\n      button.react-date-picker__calendar-button,\n      button.react-datetime-picker__calendar-button {\n        padding-left: 12px;\n        padding-right: 4px;\n        border-left: 1px solid ", ";\n      }\n\n      input {\n        font-family: ", ";\n        padding-left: 2px;\n        padding-right: 2px;\n      }\n\n      input:focus {\n        outline: none;\n      }\n    }\n\n    &.react-date-picker--open {\n      .react-date-picker__wrapper {\n        border: 1px solid ", ";\n      }\n    }\n\n    &.react-datetime-picker--open {\n      .react-datetime-picker__wrapper {\n        border: 1px solid ", ";\n      }\n    }\n\n    &.react-date-picker--disabled,\n    &.react-datetime-picker--disabled {\n\n      .react-date-picker__wrapper,\n      .react-datetime-picker__wrapper {\n        background: #F7F7F7;\n      }\n\n      background: transparent;\n      line, rect, path {\n        stroke: ", " !important;\n      }\n\n      input::placeholder {\n        color: ", " !important;\n      }\n\n      .react-date-picker__inputGroup__divider,\n      .react-datetime-picker__inputGroup__divider {\n        color: ", " !important;\n      }\n\n\n    }\n  "], ["\n    .react-date-picker__inputGroup__input--hasLeadingZero,\n      .react-datetime-picker__inputGroup__input--hasLeadingZero {\n        margin-left: -2px !important;\n      }\n\n    .react-calendar {\n      top: 1px;\n      transition: border 0.2s;\n      position: relative;\n      border: 1px solid ", ";\n      font-family: ", ";\n\n\n      .react-calendar__month-view__days__day--weekend {\n        color: ", ";\n      }\n\n      .react-calendar__tile--active {\n        color: #FFF;\n        background-color: ", ";\n      }\n\n      abbr {\n        text-decoration: none;\n      }\n\n      button {\n        font-weight: 400;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        font-family: ", ";\n        font-size: ", ";\n      }\n\n      button.react-calendar__navigation__arrow {\n        font-family: 'Trebuchet MS', Arial, sans-serif;\n        font-size: ", ";\n        padding-top: 0px;\n        padding-bottom: 0px;\n      }\n\n      button.react-calendar__navigation__label {\n        padding: 0;\n        text-transform: uppercase;\n        font-weight: 500;\n        font-size: ", ";\n      }\n\n      .react-calendar__navigation {\n        margin-bottom: 6px;\n        border-bottom: 1px solid ", "; \n      }\n    \n    \n    }\n\n    .react-date-picker__wrapper {\n      width: 220px;\n    }\n\n    .react-datetime-picker__wrapper {\n      width: 280px;\n    }\n\n    .react-date-picker__wrapper,\n    .react-datetime-picker__wrapper {\n      padding: ", ";\n      transition: border 0.2s;\n      flex-grow: 0;\n      border: 1px solid ", ";\n      \n      button {\n        svg {\n          height: 16px;\n          width: 16px;\n        }\n        padding-left: 12px;\n        padding-right: 12px;\n        outline: none;\n        line, rect, path {\n          stroke: ", ";\n        }\n\n        &:focus, &:hover {\n          line, rect, path {\n          stroke: ", ";\n        }\n        }\n      }\n\n      .react-date-picker__inputGroup,\n      .react-datetime-picker__inputGroup {\n        padding: ", ";\n      }\n\n      button.react-date-picker__calendar-button,\n      button.react-datetime-picker__calendar-button {\n        padding-left: 12px;\n        padding-right: 4px;\n        border-left: 1px solid ", ";\n      }\n\n      input {\n        font-family: ", ";\n        padding-left: 2px;\n        padding-right: 2px;\n      }\n\n      input:focus {\n        outline: none;\n      }\n    }\n\n    &.react-date-picker--open {\n      .react-date-picker__wrapper {\n        border: 1px solid ", ";\n      }\n    }\n\n    &.react-datetime-picker--open {\n      .react-datetime-picker__wrapper {\n        border: 1px solid ", ";\n      }\n    }\n\n    &.react-date-picker--disabled,\n    &.react-datetime-picker--disabled {\n\n      .react-date-picker__wrapper,\n      .react-datetime-picker__wrapper {\n        background: #F7F7F7;\n      }\n\n      background: transparent;\n      line, rect, path {\n        stroke: ", " !important;\n      }\n\n      input::placeholder {\n        color: ", " !important;\n      }\n\n      .react-date-picker__inputGroup__divider,\n      .react-datetime-picker__inputGroup__divider {\n        color: ", " !important;\n      }\n\n\n    }\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.FONT('sans'), theme_1.theme.COLOR('text-very-subtle'), theme_1.theme.COLOR('primary'), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(14), theme_1.theme.FONT_SIZE(24), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('line-mid'), theme_1.theme.COLOR('line'), theme_1.theme.COLOR('link'), theme_1.theme.UNIT(1), theme_1.theme.COLOR('line-subtle'), theme_1.theme.FONT('sans'), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('line-mid'), theme_1.theme.COLOR('line-mid'), theme_1.theme.COLOR('line-mid'))
});
var DateContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 280px;\n    box-sizing: border-box;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 280px;\n    box-sizing: border-box;\n  "])))
});
var StartStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), DateContainerStyles)
});
var EndStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    margin-left: ", ";\n  "], ["\n    ", ";\n    margin-left: ", ";\n  "])), DateContainerStyles, theme_1.theme.UNIT(3))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: ", " ", ";\n    background: ", ";\n    border: 1px solid ", ";\n    border-bottom: none;\n  "], ["\n    padding: ", " ", ";\n    background: ", ";\n    border: 1px solid ", ";\n    border-bottom: none;\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('line-mid'))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  DatePicker: (0, styled_components_1.default)(react_date_picker_1.default)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), DatePickerStyles),
  DateTimePicker: (0, styled_components_1.default)(react_datetime_picker_1.default)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), DatePickerStyles),
  Label: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Start: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), StartStyles),
  End: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), EndStyles)
};
var InputDateComponent = function (props) {
  var className = props.className,
    onChange = props.onChange,
    onBlur = props.onBlur,
    includeTime = props.includeTime,
    endFieldName = props.endFieldName,
    field = props.field;
  if (!field) {
    throw new Error('InputDate requires a field specification.');
  }
  var t = (0, use_lang_1.useLang)();
  var placeholder = field.placeholder,
    name = field.name,
    valid = field.valid,
    value = field.value,
    disabled = field.disabled;
  var formState = (0, use_form_state_1.useFormState)();
  var endValue = endFieldName && (0, lodash_1.get)(formState, "".concat(endFieldName, ".value"));
  var date = value ? fecha_1.default.parse(value, 'YYYY-MM-DD') : null;
  var datetime = value ? fecha_1.default.parse(value, 'YYYY-MM-DDTHH:mm') : null;
  var endDate = endValue ? fecha_1.default.parse(endValue, 'YYYY-MM-DD') : null;
  var endDatetime = endValue ? fecha_1.default.parse(endValue, 'YYYY-MM-DDTHH:mm') : null;
  var handleChange = function (date) {
    var _a;
    var newValue = date ? fecha_1.default.format(date, 'YYYY-MM-DD') : '';
    var options = endFieldName ? !endValue ? {
      extraFieldValues: (_a = {}, _a[endFieldName] = {
        value: newValue
      }, _a)
    } : {} : {};
    onChange({
      name: name,
      value: newValue,
      options: options
    });
  };
  var handleTimeChange = function (date) {
    var _a;
    var newValue = date ? fecha_1.default.format(date, 'YYYY-MM-DDTHH:mm') : '';
    var options = endFieldName ? !endValue ? {
      extraFieldValues: (_a = {}, _a[endFieldName] = {
        value: newValue
      }, _a)
    } : {} : {};
    onChange({
      name: name,
      value: newValue,
      options: options
    });
  };
  var handleEndChange = function (date) {
    onChange({
      name: endFieldName,
      value: date ? fecha_1.default.format(date, 'YYYY-MM-DD') : ''
    });
  };
  var handleEndTimeChange = function (date) {
    onChange({
      name: endFieldName,
      value: date ? fecha_1.default.format(date, 'YYYY-MM-DDTHH:mm') : ''
    });
  };
  return React.createElement(My.Container, {
    className: className,
    field: field
  }, React.createElement(My.Body, null, React.createElement(My.Start, null, endFieldName && React.createElement(My.Label, null, t('Start')), includeTime ? React.createElement(My.DateTimePicker, {
    name: name,
    showLeadingZeros: true,
    disabled: disabled,
    value: datetime,
    onChange: handleTimeChange
  }) : React.createElement(My.DatePicker, {
    name: name,
    showLeadingZeros: true,
    disabled: disabled,
    value: date,
    onChange: handleChange
  })), endFieldName && React.createElement(My.End, null, React.createElement(My.Label, null, t('End')), includeTime ? React.createElement(My.DateTimePicker, {
    name: endFieldName,
    showLeadingZeros: true,
    disabled: disabled,
    value: endDatetime,
    onChange: handleEndTimeChange
  }) : React.createElement(My.DatePicker, {
    name: endFieldName,
    showLeadingZeros: true,
    minDate: date,
    disabled: disabled,
    value: endDate,
    onChange: handleEndChange
  }))));
};
exports.InputDateComponent = InputDateComponent;
exports.InputDateComponent.defaultProps = exports.InputDateDefaultProps;
var createInputDate = function (props) {
  return React.createElement(exports.InputDate, __assign({}, props));
};
exports.createInputDate = createInputDate;
exports.InputDate = memo(exports.InputDateComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;